import { Provider } from '@angular/core';

import { AcquisitionApiService } from './acquisition-api.service';
import { AcquisitionHttpService } from './acquisition-http.service';

/** Registra la implementación de `AcquisitionApiService` que usa la app. */
export function provideAcquisition(): Provider[] {
  return [{ provide: AcquisitionApiService, useClass: AcquisitionHttpService }];
}
